<!-- <div class="wrap_all"> -->
<header-share></header-share>
<main
  id="content"
  [ngClass]="{ pagnation_wrap: myTab == 'faq' || myTab == 'notice' }"
>
  <div class="mypage_con">
    <nav class="tab_menu">
      <h2 class="hidden">마이페이지 하위 탭메뉴</h2>
      <div class="nav_area">
        <mat-button-toggle-group
          name="tabMenu"
          appearance="legacy"
          aria-label="마이페이지 메뉴"
          [(ngModel)]="myTab"
        >
          <mat-button-toggle value="myfeed">마이피드</mat-button-toggle>
          <mat-button-toggle value="faq">자주하는 질문</mat-button-toggle>
          <mat-button-toggle value="notice">공지사항</mat-button-toggle>
          <mat-button-toggle value="editInfo">내정보수정</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <div class="search_area" *ngIf="myTab == 'faq'">
        <h2 class="hidden">자주하는 질문 검색</h2>
        <input
          type="search"
          placeholder="검색어를 입력하세요."
          maxlength="20"
          [(ngModel)]="searchKeyword"
        />
        <button class="search_btn" (click)="searchFaq()">검색하기</button>
      </div>
    </nav>
  </div>

  <div class="con_wrap" *ngIf="user">
    <!--1 마이피드-->
    <section class="myfeed_wrap" *ngIf="myTab == 'myfeed'">
      <!--card area-->
      <h2 class="hidden">내 피드 목록</h2>

      <div class="card_wrap" *ngFor="let feed of allFeed | async">
        <div class="card_top">
          <div class="hastag">
            <span>#{{ feed?.StepTwoCard?.title }}</span>
            <span>#{{ feed?.StepThreeCard?.card }}</span>
          </div>
        </div>

        <div class="txt_area">
          <p>{{ feed?.successCard }}</p>

          <div class="btn_box">
            <span class="date_area">{{
              feed?.dateCreated | date: "yy.MM.dd"
            }}</span>
            <div class="btn_area">
              <button class="upload" (click)="openUpLoad(feed?.id)">
                올리기
              </button>
              <button class="remove" (click)="openRemove(feed?.id)">
                지우기
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--2 faq-->
    <section class="faq" *ngIf="myTab == 'faq'">
      <h2 class="hidden">자주하는 질문 글 목록</h2>
      <div *ngIf="faqs$ | async as faqs">
        <div class="list_area">
          <mat-accordion
            class="example-headers-align"
            *ngFor="let item of faqs | search: searchKeyword | paginate: { itemsPerPage: 4, currentPage: p1, id: 'faq' };
              let i = index
            "
          >
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title> {{ item.title }} </mat-panel-title>
              </mat-expansion-panel-header>
              <p>{{ item.content }}</p>
            </mat-expansion-panel>
          </mat-accordion>

          <div
            class="no_search"
            *ngIf="
              faqs.length == 0 || (faqs | search: searchKeyword)?.length == 0
            "
          >
            검색 결과가 없습니다.
          </div>
        </div>
      </div>
    </section>

    <!--3 공지사항-->
    <section class="faq" *ngIf="myTab == 'notice'">
      <h2 class="hidden">공지사항</h2>
      <div class="list_area">
        <mat-accordion
          class="example-headers-align"
          *ngFor="
            let item of notices$
              | async
              | search: searchKeyword
              | paginate: { itemsPerPage: 4, currentPage: p2, id: 'notice' } ;
            let i = index
          "
        >
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title
                ><span class="title_num">{{ i + 1 }}</span> {{ item.title }}
                <span class="notice_date">{{
                  item.dateCreated | date: "yy-MM-dd"
                }}</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p>{{ item.content }}</p>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </section>

    <section *ngIf="myTab == 'editInfo'" class="info">
      <div class="ck_pwd" *ngIf="passwordTrue !== true">
        <form class="form_wrap">
          <fieldset>
            <legend>비밀번호 확인</legend>
            <p>개인 정보 보호를 위해 비밀번호를 다시 한번 확입합니다.</p>
            <div class="input_area">
              <p class="input_wrap">
                <label for="uname" class="hidden">비밀번호</label>
                <input
                  type="password"
                  name="ckpwd"
                  id="ckpwd"
                  class="ckpwd"
                  placeholder="비밀번호를 입력해주세요."
                  [(ngModel)]="check.password"
                  minlength="6"
                  maxlength="15"
                  (input)="(check.password)"
                  (focus)="focus($event)"
                />
              </p>
              <p class="vdt" *ngIf="passwordTrue == false && checkValid == true">
                잘못된 비밀번호입니다. 다시 입력해주세요.
              </p>
            </div>
            <div class="info_btn">
              <button
                class="ck_pwd_btn"
                (click)="pwdCheck(user)"
                [disabled]="check.password == ''"
              >
                확인
              </button>
            </div>
          </fieldset>
        </form>
      </div>

      <!--비밀번호 맞다면-->
      <div
        class="ok_info_wrap"
        *ngIf="passwordTrue == true && chagePassword == false"
      >
        <h2>가입정보</h2>
        <p class="info_id">
          <span class="id_title">아이디</span
          ><span class="id_txt">{{ user.id }}</span>
        </p>

        <form action="" class="form_wrap">
          <fieldset>
            <legend>회원정보</legend>
            <div class="input_area">
              <p class="input_wrap">
                <label for="uname">이름</label>
                <input
                  type="text"
                  name="uname"
                  id="uname"
                  class="uname"
                  placeholder="홍길동"
                  minlength="2"
                  maxlength="7"
                  [(ngModel)]="user.name"
                />
                <span class="notice_txt">(실명을 입력해 주세요.)</span>
              </p>
              <p class="vdt" *ngIf="!user.name">이름을 입력해주세요.</p>
            </div>
            <div class="input_area">
              <p class="input_wrap">
                <label for="uname">학교</label>
                <input
                  type="text"
                  name="school"
                  id="school"
                  class="uname"
                  placeholder="한국중학교"
                  maxlength="10"
                  [(ngModel)]="user.school"
                />
                <span class="notice_area">
                  <span class="notice_txt txt1"
                    >(초등학교 혹은 중학교까지 입력해주세요.)</span
                  >
                  <span class="notice_txt"
                    >(예-한국초등학교혹은 한국중학교)</span
                  >
                </span>
              </p>
              <p class="vdt" *ngIf="!user.school">학교를 입력해주세요</p>
            </div>

            <div class="input_area select_area">
              <p class="input_wrap">
                <label for="schoolyear">학년</label>
                <select
                  name="schoolyear"
                  id="schoolyear"
                  class="schoolyear"
                  [(ngModel)]="user.grade"
                >
                  <!--placeholder 대체 option-->
                  <option *ngFor="let item of schoolYear" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </p>
              <p class="vdt" *ngIf="user.grade == 'placeholder'">
                학년을 입력해주세요
              </p>
            </div>

            <div class="input_area select_area">
              <p class="input_wrap">
                <label for="schoolyear">지역</label>
                <select
                  name="schoolArea"
                  id="schoolArea"
                  class="schoolArea"
                  [(ngModel)]="user.region"
                >
                  <!--placeholder 대체 option-->
                  <option *ngFor="let item of schoolArea" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </p>
              <p class="vdt" *ngIf="user.region == 'placeholder'">
                지역을 입력해주세요
              </p>
            </div>

            <div class="input_area">
              <div class="input_wrap gender_box">
                <p class="gender_title">성별</p>

                <input
                  type="radio"
                  name="gender"
                  value="male"
                  id="male"
                  [(ngModel)]="user.gender"
                />
                <label for="male" class="radio_label"><span>남자</span></label>
                <input
                  type="radio"
                  name="gender"
                  value="female"
                  id="female"
                  [(ngModel)]="user.gender"
                />
                <label for="female" class="radio_label"
                  ><span>여자</span></label
                >
              </div>
              <p class="vdt" *ngIf="!user.gender">성별을 선택해주세요.</p>
            </div>

            <div class="input_area">
              <p class="input_wrap">
                <label for="teacherCode">선생님 코드</label>
                <input
                  type="text"
                  name="teacherCode"
                  id="teacherCode"
                  class="teacher_code"
                  maxlength="8"
                  [(ngModel)]="user.teacherCode"
                />
                <span class="notice_txt"
                  >(담당 선생님의 코드를 입력해 주세요.)</span
                >
              </p>
              <p class="vdt" *ngIf="!user.teacherCode">코드를 확인해주세요.</p>
            </div>
          </fieldset>
        </form>
        <div class="info_btn">
          <button class="pw_btn" (click)="cgPwd()">비밀번호 변경</button>
          <button class="save_info_btn" (click)="profileEdit()">
            저장하기
          </button>
          <button class="exit_btn" (click)="openExit()">회원탈퇴</button>
        </div>
      </div>

      <!--4-2 비밀번호 변경-->

      <div class="ok_info_wrap password_wrap" *ngIf="chagePassword == true">
        <h2>비밀번호 변경</h2>
        <form class="pwd_form">
          <div class="input_area">
            <p class="input_wrap">
              <label for="pwd">기존 비밀번호</label>
              <input
                type="password"
                name="pwd"
                id="pwd"
                class="pwd"
                placeholder=" "
                minlength="6"
                maxlength="15"
                [(ngModel)]="chage.password"
              />
              <span class="notice_txt"
                >(기존 비밀번호를 다시한번 입력해 주세요.)</span
              >
            </p>
            <p
              class="vdt"
              *ngIf="
                chage.password.length > 0 && check.password !== chage.password
              "
            >
              기존 비밀번호와 일치하지 않습니다. 다시 입력해주세요.
            </p>
          </div>
          <div class="input_area">
            <p class="input_wrap">
              <label for="newpwd">신규 비밀번호</label>
              <input
                type="password"
                name="newpwd"
                id="newpwd"
                class="newpwd"
                placeholder=" "
                minlength="6"
                maxlength="15"
                [(ngModel)]="chage.repassword"
              />
              <span class="notice_txt"
                >(영문,숫자,특수문자를 이용한 6~15자리)</span
              >
            </p>
            <p
              class="vdt"
              *ngIf="
                (chage.repassword.length > 0 && chage.repassword.length < 5) ||
                chage.repassword.length > 16
              "
            >
              입력조건에 맞게 비밀번호를 다시 설정해주세요.
            </p>
          </div>
          <div class="input_area">
            <p class="input_wrap">
              <label for="repwd">비밀번호 확인</label>
              <input
                type="password"
                name="repwd"
                id="repwd"
                class="repwd"
                placeholder=" "
                minlength="6"
                maxlength="15"
                [(ngModel)]="chage.confirmPassword"
              />
            </p>
            <p
              class="vdt"
              *ngIf="
                chage.confirmPassword.length > 0 &&
                chage.repassword !== chage.confirmPassword
              "
            >
              신규 비밀번호와 일치하지 않습니다. 다시 입력해주세요.
            </p>
          </div>
        </form>
        <button
          class="pwd_btn"
          (click)="changePassword()"
          [disabled]="
            chage.repassword.length < 5 ||
            chage.repassword.length > 16 ||
            chage.repassword !== chage.confirmPassword
          "
        >
          저장하기
        </button>
      </div>
    </section>
  </div>
</main>

<!--페이지 네이션 영역-->
<div class="pagenation_area" *ngIf="myTab == 'faq'">
  <!--butto에 disabled 각각 걸려있습니다.!-->
  <button class="first_btn" [disabled]="p1 == 1" (click)="firstPage()">
    첫번째 페이지
  </button>
  <pagination-controls
    (pageChange)="p1 = $event" 
    screenReaderPaginationLabel="페이지 이동"
    screenReaderPageLabel="다음페이지"
    screenReaderCurrentLabel="현재페이지"
    autoHide="false"
    previousLabel=" "
    nextLabel=" "
    responsive=true
    id="faq"
  ></pagination-controls>
  <button
    class="last_btn"
    [disabled]="p1 >= list.length / 4"
    (click)="lastPage()"
  >
    마지막 페이지
  </button>
</div>

<div class="pagenation_area" *ngIf="myTab == 'notice'">
  <!--butto에 disabled 각각 걸려있습니다.!-->
  <button class="first_btn" disabled="false">첫번째 페이지</button>
  <pagination-controls
    (pageChange)="p2 = $event"
    pagination-controls
    screenReaderPaginationLabel="페이지 이동"
    screenReaderPageLabel="다음페이지"
    screenReaderCurrentLabel="현재페이지"
    autoHide="false"
    previousLabel=" "
    nextLabel=" "
    responsive=true
    id="notice"
  ></pagination-controls>
  <button class="last_btn">마지막 페이지</button>
</div>
<footer-share></footer-share>
